import { useCommentLikeModal } from "../../context/CommentLikeModalContext";
import ReactionAvatarModal from "./ReactionAvatarModal";
import useGetUserDetailsById from "../../hooks/useGetUserDetailsById";
import LikeReaction from "../../assets/img/reactions/like.svg";
import LoveReaction from "../../assets/img/reactions/love.svg";
import LaughReaction from "../../assets/img/reactions/laugh.svg";
import SanaOlReaction from "../../assets/img/reactions/sanaol.svg";
import LodiReaction from "../../assets/img/reactions/lodi.svg";
import ReactionModalStyles from "./ReactionModalStyles.module.css";

const reactionIcons: Record<string, string> = {
  Like: LikeReaction,
  Love: LoveReaction,
  Sanaol: SanaOlReaction,
  Laugh: LaughReaction,
  Lodi: LodiReaction,
};

// Per-row component so useGetUserDetailsById can be called per reactor —
// mirrors mobile's LikeListCard which fetches user details by id.
type ReactionRowProps = {
  id: number;
  email?: string;
  reaction?: string;
};

const ReactionRow = ({ id, email, reaction }: ReactionRowProps) => {
  const { userDetailsById, isLoading } = useGetUserDetailsById(id);
  const user = userDetailsById?.user;

  // Same display name logic as mobile LikeListCard
  const displayName = user
    ? user.preferredName
      ? `${user.preferredName} ${user.lastName ?? ""}`.trim()
      : `${user.firstName ?? ""} ${user.lastName ?? ""}`.trim()
    : "";

  const reactionIcon = reactionIcons[reaction ?? ""];

  if (isLoading) return null;

  return (
    <div className={ReactionModalStyles.flexBoxBlk}>
      <div className={ReactionModalStyles.avatarSectionBlk}>
        <div className={ReactionModalStyles.reactionSectionBlk}>
          {reactionIcon && <img alt="Reaction Icon" src={reactionIcon} />}
        </div>
        <ReactionAvatarModal userId={id} />
      </div>
      <div>
        <div className={ReactionModalStyles.flexBoxBlkInside}>
          <h3>{displayName}</h3>
        </div>
        <p>{email}</p>
      </div>
    </div>
  );
};

const ReactionModal = () => {
  const { closeModal, data } = useCommentLikeModal();

  const shouldScroll = (data?.reactions?.length ?? 0) > 5;

  return (
    <div className={ReactionModalStyles.reactionModalContainer}>
      <div className={ReactionModalStyles.reactionModalMain}>
        <i className="fa-solid fa-xmark" onClick={closeModal}></i>
        <h1>Reactions</h1>
        <div
          className={ReactionModalStyles.container}
          style={
            shouldScroll
              ? { overflowY: "scroll", maxHeight: "250px" }
              : undefined
          }
        >
          {data?.reactions?.map((item, index) => (
            <ReactionRow
              key={index}
              id={Number(item?.id)}
              email={item?.email}
              reaction={item?.reaction}
            />
          ))}
        </div>
      </div>
    </div>
  );
};

export default ReactionModal;
